
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudyProtocolVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StudyProtocolVersion"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"protocolVersion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProtocolVersion"},"directives":[]}]}}]}}],"loc":{"start":0,"end":170}};
    doc.loc.source = {"body":"#import \"./ProtocolVersionFragment.graphql\"\n\nfragment StudyProtocolVersion on StudyProtocolVersion {\n    studyId,\n    protocolVersion {\n        ...ProtocolVersion\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./ProtocolVersionFragment.graphql").definitions));


      module.exports = doc;
    
